module.exports = __webpack_public_path__ + "static/media/viewArrow.149d0fa7.svg";